import { Component, Input } from '@angular/core';

import { ProgramDetails } from '../../models';

@Component({
    selector: 'opus-program-additional',
    templateUrl: './program-additional.component.html',
})
export class ProgramAdditionalComponent {
    @Input() program: ProgramDetails;
    flyers = [
        { id: 0, name: 'Digital' },
        { id: 1, name: 'Physical' },
        { id: 2, name: 'Hybrid' },
    ]

    get beginningGrade() {
        if (this.program.beginningGrade == null) {
            return 'Unknown';
        }

        const value = Number.parseInt(this.program.beginningGrade);
        if (value == null || value < 0) {
            return 'Unknown';
        }
        else if (value == 0) {
            return 'K';
        }
        else if (value > 12) {
            return 'College';
        }

        return value.toString();
    }

    get rentalFlyers() {
        if (this.program.rentalFlyers == null) {
            return 'Unknown';
        }

        const value = this.program.rentalFlyers;
        if (value == null || value < 0) {
            return 'Unknown';
        }

        const fly = this.flyers.find(itm => itm.id == value);


        return fly.name;
    }
}
